import { ReactElement, useState } from 'react';
import { NavigatorTab } from '@components/common/navigator-tab';
import { SiteSummaryTab, SiteSummaryTabKAESSUser, SiteSummaryTabKAEUser } from '@components/siteSummary/index';
import {
	SiteSummaryCard,
	SiteSummaryFilters,
	SiteSummaryFilterTag,
	SiteSummarySearch,
} from '@components/siteSummary/components';
import { useSiteSummaryListing } from '@services/hooks/site-summary-listing';
import { Wrapper } from '@components/common/Wrapper/wrapper';
import { useSiteSummaryRxDb } from '@services/hooks/site-summary-listing/useSiteSummaryRxDb';
import { SiteStatusModal, Sort, useInfiniteScroll } from '@components/common';
import { NoDataFound } from '@components/common/no-data-found/noDataFound';
import { useFilterStore } from '@store/filter';
import { overlayAddFadeAction, overlayRemoveFadeAction } from '@components/common/sort';
import { useSiteSummaryListingStore } from '@store/siteSummaryListingFilterStore';
import { Modal } from '@components/common/modal/modal';
import { useContractor360Store } from '@store/contractor360Store';
import { useFormik } from 'formik';
import { useComponentLevelAccessCheck } from '../../authGuard/hooks/useComponentLevelAccessCheck';

export const KAESSSiteSpecialistSiteList = (): ReactElement => {
	const [openSort, setOpenSort] = useState<boolean>(false);
	const [openFilter, setOpenFilter] = useState<boolean>(false);
	const checkKaessSitePermissions = useComponentLevelAccessCheck('add-site-button');
	const checkKaeTabSitePermissions = useComponentLevelAccessCheck('site-specialist-tab');
	const { isFetching: queryFetching, error } = useSiteSummaryListing();
	const { search, sortValue } = useFilterStore();
	const { allSiteSummaryFilter } = useSiteSummaryListingStore();
	const { isSiteStatusModalOpen, setSiteStatusModal } = useContractor360Store();
	const {
		result: data,
		isFetching,
		fetchMore,
		totalCount,
	} = useSiteSummaryRxDb({
		name: search,
		sortBy: sortValue,
		current_stage_of_site_c: 'New Lead',
		competition_site: allSiteSummaryFilter.competition_site,
		adopted_site: allSiteSummaryFilter.adopted_site,
		lastactivitydate: allSiteSummaryFilter.lastactivitydate,
	});
	const formik = useFormik({
		initialValues: {
			siteStatus: '',
		},
		onSubmit: () => {},
	});

	useInfiniteScroll(() => {
		fetchMore();
	});
	let selectedTabList;

	if (!checkKaessSitePermissions) {
		selectedTabList = SiteSummaryTabKAESSUser;
	} else if (!checkKaeTabSitePermissions) {
		selectedTabList = SiteSummaryTabKAEUser;
	} else {
		selectedTabList = SiteSummaryTab;
	}
	return (
		<>
			<section className="tab-search-section" id="site-summary">
				<div className="container">
					<NavigatorTab tabList={selectedTabList} selectedFilterChild={<SiteSummaryFilterTag count={totalCount} />}>
						<SiteSummarySearch
							setSortCallback={() => setOpenSort(true)}
							setFilterCallback={() => overlayAddFadeAction(() => setOpenFilter(true))}
						/>
					</NavigatorTab>

					<Wrapper
						isError={error && new Error(`${error}`)}
						isLoaderVisible={queryFetching || (isFetching && data.length === 0)}
					>
						<div className="site-summary-card-wrapper">
							<ul className="row">
								{data && data.length !== 0 ? (
									data.map((site) => <SiteSummaryCard key={site.id} site={site} showKaeFields={true} />)
								) : (
									<NoDataFound />
								)}
							</ul>
						</div>
					</Wrapper>
				</div>
			</section>
			{openSort && <Sort setSortOpen={() => overlayRemoveFadeAction(() => setOpenSort(false))} />}
			{openFilter && (
				<SiteSummaryFilters
					openFilters={openFilter}
					closeFilters={() => overlayRemoveFadeAction(() => setOpenFilter(false))}
					isHideFTQFilter={true}
					isHideKAESSFilter={true}
				/>
			)}
			<Modal
				modalId="siteStatus"
				className="dialog dialog-sm site-summary-status-popup close-site-popup pt-4"
				modalOpen={isSiteStatusModalOpen}
				onModalClose={() => setSiteStatusModal(false)}
			>
				<SiteStatusModal formik={formik} />
			</Modal>
		</>
	);
};
